import type {AddSupplierContactFormPayload} from "./add-supplier-contact.schema";

import {addSupplierContact} from "@project/sdk/engineering";
import {AddSupplierContactBody} from "@project/sdk/engineering/zod";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../../../supplier-keys";

import {addSupplierContactMapper} from "./add-supplier-contact.mapper";

export function addSupplierContactMutationOptions(supplierId: string) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.addSupplierContact,
    mutationFn: (payload: AddSupplierContactFormPayload) => {
      const request = AddSupplierContactBody.parse(addSupplierContactMapper.toSdk(payload));
      return addSupplierContact(supplierId, request);
    },
    onSuccess: async (_contactId, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(supplierId)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
